import type { ReactNode } from "react";
import type { PostedRow } from "../../types/account";
import { usePostedRowRemoval } from "../../hooks/usePostedRowRemoval";
import { formatAmount } from "../../utils/currency";
import { ErrorMessage } from "../ErrorMessage";

interface PostedRowsListProps {
  clientId: number;
  rows: PostedRow[];
  /** The account's currency; null shows the figures with no symbol. */
  currency: string | null;
  onChanged: () => void;
}

/**
 * The personal move's list: each row already in the business books, with
 * Undo (the review row's undo, the same call, named as the server's notice
 * names it) where its entry offers it.
 */
export function PostedRowsList({
  clientId,
  rows,
  currency,
  onChanged,
}: PostedRowsListProps): ReactNode {
  const { canRemove, remove, removed, refusal } = usePostedRowRemoval(clientId, rows, onChanged);
  if (rows.length === 0) return null;
  return (
    <div className="account-posted-rows">
      {refusal && <ErrorMessage message={refusal} />}
      <ul>
        {rows.map((row) => (
          <li key={`${row.side}-${row.transaction_id}`}>
            <span>{row.date}</span> <span>{row.description}</span>{" "}
            <span>{formatAmount(row.amount, currency)}</span>
            {canRemove(row.transaction_id) && !removed.has(row.transaction_id) && (
              <button type="button" onClick={() => void remove(row.transaction_id)}>
                Undo
              </button>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
